/* components imports */
import Favorite from '../components/favorite/Favorite';

const MyFavoritePage = () => {
    return <Favorite />
}

export default MyFavoritePage